import axios, {AxiosProgressEvent} from 'axios';
// @ts-ignore
import {loadFromStorage, deleteFromStorage, clearStorage} from './LocalStorage.tsx';

export const OriginBackendUrl = "https://weexplan.com/backend";

type CatchCallback = (error: any) => void;
type UpdateProgressCallback = (progress: number) => void;

export async function uploadImage(image: File, updateImagesUploadProgress: (imageName: string, progress: number) => void, catchCB: CatchCallback = stdCatch): Promise<any>{
  const BackendUrl = localStorage.getItem("backendUrl")
  const token = await loadToken();
  const data = new FormData();
  data.append('image', image);

  try{
    const response = await axios.post(BackendUrl + '/uploads', data, {
      headers: {
        'Content-Type': 'multipart/form-data', Authorization: 'Bearer ' + token
      }, onUploadProgress: (progressEvent: AxiosProgressEvent) => {
        // @ts-ignore
        const progress = progressEvent.loaded / progressEvent.total;
        updateImagesUploadProgress(image.name, progress);
      }
    });

    if(!response.data['returnCode'] || response.data['returnCode'] < 299){
      return response.data;
    }
    else{
      return catchCB(response.data['errorMessage']);
    }
  }
  catch(e){
    catchCB(e);
    return {};
  }
}

export async function loadToken(): Promise<string | null>{
  try{
    const token = loadFromStorage('token');
    return token ?? null;
  }
  catch(e){
    return null;
  }
}

export async function fetchBackendAsync(url: string, catchCB: CatchCallback = stdCatch, origin: boolean = false): Promise<any>{
  const BackendUrl = url.includes("http") ? null : localStorage.getItem("backendUrl")
  console.log('fetching... ' + BackendUrl + url);
  const token = origin ? await loadToken() : await loadToken();

  try{
    const response = await axios.get((BackendUrl ?? "") + url, {
      headers: {
        'Content-Type': 'multipart/form-data', Authorization: 'Bearer ' + token
      }
    });
    return response.data;
  }
  catch(e: any){
    if(e?.response?.data?.returnCode < 500){
      catchCB(e?.response?.data?.errorMessage);
    }
    else{
      if(e?.response?.data?.returnCode === 666){
        await clearStorage();
        await deleteFromStorage('userToken');
      }
      catchCB(`${e.toString()} url: ${BackendUrl}${url} message: ${e?.response?.data?.message} - ${JSON.parse(e.request?.response ? e.request?.response : "{}")?.trace}`);
    }
    return null;
  }
}

export async function deleteBackendAsync(url: string, catchCB: CatchCallback = stdCatch, origin: boolean = false): Promise<any>{
  const BackendUrl = localStorage.getItem("backendUrl")
  console.log('fetching... ' + BackendUrl + url);
  const token = origin ? await loadToken() : await loadToken();

  try{
    const response = await axios.delete(BackendUrl + url, {
      headers: {
        'Content-Type': 'multipart/form-data', Authorization: 'Bearer ' + token
      }
    });
    return response.data;
  }
  catch(e: any){
    if(e?.response?.data?.returnCode < 500){
      catchCB(e?.response?.data?.errorMessage);
    }
    else{
      if(e?.response?.data?.returnCode === 666){
        await clearStorage();
        await deleteFromStorage('userToken');
      }
      catchCB(`${e.toString()} url: ${BackendUrl}${url} message: ${e?.response?.data?.message} - ${JSON.parse(e.request?.response)?.trace}`);
    }
    return null;
  }
}

export async function postBackendAsync(url: string, payload: any, catchCB: CatchCallback = stdCatch, origin: boolean = false, updateProgress: UpdateProgressCallback | null = null): Promise<any>{
  const token = await loadToken();
  const BackendUrl = url.includes("http") ? null : localStorage.getItem("backendUrl")
  const backend = origin ? OriginBackendUrl : BackendUrl;
  console.log('posting... ' + backend + url);

  try{
    const response = await axios.post((backend ?? "") + url, JSON.stringify(payload), {
      headers: {
        'Content-Type': 'application/json', Authorization: 'Bearer ' + token
      }, onUploadProgress: (progressEvent: AxiosProgressEvent) => {
        // @ts-ignore
        const progress = progressEvent.loaded / progressEvent.total;
        if(updateProgress){
          updateProgress(progress);
        }
      }
    });
    return response.data;
  }
  catch(e: any){
    if(e?.response?.data?.returnCode < 500){
      catchCB(e?.response?.data?.errorMessage);
    }
    else{
      catchCB(`${e.toString()} url: ${backend}${url} message: ${e?.response?.data?.message} - ${e.request?.response}`);
    }
    return null;
  }
}

function stdCatch(response: any): void{
  console.log('error fetching or posting data:');
  console.log(response);
  console.log('error occurred at:');
  console.trace();
}

function thenWrapper(thenCB: (data: any) => void, catchCB: CatchCallback){
  return (response: any) => {
    if(response.data['returnCode'] < 299 && response.data['returnCode'] > 199){
      return thenCB(response.data);
    }
    else{
      return catchCB(response.data['errorMessage']);
    }
  };
}
